import axios, { AxiosError, AxiosRequestConfig } from "axios"

import { runtimeConfig } from "./runtimeConfig"

const createHTTPClient = (baseURL: string, options: AxiosRequestConfig) => {
  const client = axios.create({
    baseURL,
    ...options,
  })

  client.interceptors.request.use(
    async (config) => {
      const token = await window.Clerk.session?.getToken()
      if (!token) return config

      config.headers.Authorization = `Bearer ${token}`

      // Add referral URL for analytics tracking (using custom header)
      if (typeof window !== "undefined") {
        // Use native document.referrer for analytics tracking
        const referrer = document.referrer || window.location.href
        config.headers["x-referer"] = referrer
      }

      return config
    },
    (error) => Promise.reject(error),
  )

  client.interceptors.response.use(
    (response) => response,
    async (error) => {
      if (error instanceof AxiosError) {
        return Promise.reject(error.response?.data)
      }
      return Promise.reject(error)
    },
  )

  return client
}

export const apiClientWithTimeout = createHTTPClient(
  runtimeConfig.VITE_API_URL,
  {
    timeout: 40000, // 40 seconds timeout
  },
)
export const apiClient = createHTTPClient(runtimeConfig.VITE_API_URL, {
  timeout: 40000, // 40 seconds timeout
})
export const apiClientWithLargeTimeout = createHTTPClient(
  runtimeConfig.VITE_API_URL,
  {
    timeout: 300000, // 5 minutes timeout for long-running operations like SSE
  },
)
